module.exports = __webpack_public_path__ + "img/pumping-activities-icon1.1b177d5c.png";